export default __webpack_public_path__ + "static/media/AppDetailsHeroBg.75513bce.png";